import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ApiRequest } from "src/app/_models";
import { EmailModel } from "src/app/_models/common/EmailModel";
import { Claims } from "src/app/_models/common/claims";
import { UserRequestBase, Userrequestdto} from "src/app/_models/user/userrequestdto";
import { AuthenticationService } from "src/app/_services";
import { EmailService } from "src/app/_services/common/email.service";
import jwt_decode from "jwt-decode";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from '../../../shared/design-system/button/button.component';
import { TextboxComponent } from '../../../shared/design-system/textbox/textbox.component';
import { ExistingDomainComponent } from "./existing-domain/existing-domain.component";
import { TextboxConfig } from "../../../shared/design-system/textbox/textbox.modal";
import { ButtonConfig } from "../../../shared/design-system/button/button.modal";
import { EMAIL_REGEX } from "src/util/constants";
import { ApplicationSettingService } from "src/app/_services/application-setting/application-setting.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule,
      TextboxComponent, ButtonComponent, ExistingDomainComponent]
})
export class RegisterComponent implements OnInit , AfterViewInit {
  @Output() gotoNextStepEvent = new EventEmitter<any>();
  @Output() gotoLoginEvent = new EventEmitter<any>();
  @ViewChild('domainAlreadyRegisteredModal') domainModal!: ExistingDomainComponent;
  @ViewChild('emailInput') emailInput!: TextboxComponent;

  signUpConfig!: ButtonConfig;
  firstnameInputConfig!: TextboxConfig;
  lastnameInputConfig!: TextboxConfig;
  emailInputConfig!: TextboxConfig;
  claims: Claims;
  submitted = false;
  IsRegisterCanBeDisabled = false;
  emailAlreadyExists = false;
  userrequest: UserRequestBase;
  referralCode: string = "";
  registrationsubmitted = false;
  firstname: string = "";
  lastname: string = "";
  email: string = "";  
  domainName: string = "";
  emailValidationMessage: string = '';
  ShowSpecialCharErrorFName: boolean = true;
  ShowSpecialCharErrorLName: boolean = true;
  emailMaxLength: string = "100";
  /** Free-preview trial length (days), resolved from application settings ("TrialDays") via API. */
  trialDays: number = 1;

  constructor(
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private emailService: EmailService,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private applicationSettingService: ApplicationSettingService,
  ) {
    this.userrequest = new UserRequestBase();
  }

  /** Resolve the free-preview trial length ("TrialDays") from application settings via API. */
  getTrialDays(): void {
    this.applicationSettingService.GetTrialDays().subscribe((res: any) => {
      if (res?.responseInfo) {
        this.trialDays = Number(res.responseInfo);
      }
    });
  }

  xeroSignUp() {
    let token = localStorage.getItem("signupxerotoken");
    const decoded = jwt_decode(token);
    const firstName = decoded["given_name"];
    const lastName = decoded["family_name"];
    const email = decoded["email"];

    this.firstname= firstName;
    this.lastname =lastName;
    this.email = email;
  }

  ngOnInit(): void {
    this.configNameAndEmail();
    this.getTrialDays();
    this.authenticationService.logout();
    this.authenticationService.loadAccessToken();
    if (localStorage.getItem("signupxerotoken")) {
      this.xeroSignUp();
    }
    const registeredUser = localStorage.getItem("registereduser");
    const backFromOTP = localStorage.getItem("backFromOTP");
    if (registeredUser && backFromOTP) {
      const userData = JSON.parse(registeredUser);
      this.firstname = userData.FirstName || '';
      this.lastname = userData.LastName || '';
      this.email = userData.LoginId || '';
      this.configNameAndEmail();
    }
    this.setButtonConfig();
  }

  configNameAndEmail() {
    this.translate.get(['label_first_name', 'label_last_name', 'label_email', 'numeric_keys_not_allowed', 'email_placeholder']).subscribe(trans => {
    this.firstnameInputConfig = {
      id: 'first-name-input',
      label: trans['label_first_name'],
      type: 'input',
      value: this.firstname,
      required: true,
      maxLength: 30,
      isInvalid: !this.ShowSpecialCharErrorFName,
      helperText: !this.ShowSpecialCharErrorFName ? trans['numeric_keys_not_allowed'] : '',
      placeholder: this.translate.instant('e.g. John'),
      size: 'lg'
    };

    this.lastnameInputConfig = {
      id: 'last-name-input',
      label: trans['label_last_name'],
      type: 'input',
      value: this.lastname,
      maxLength: 30,
      isInvalid: !this.ShowSpecialCharErrorLName,
      helperText: !this.ShowSpecialCharErrorLName ? trans['numeric_keys_not_allowed'] : '',
      placeholder: this.translate.instant('e.g. Doe'),
      size: 'lg'
    };

    this.emailInputConfig = {
      id: 'email-textbox-input',
      label: trans['label_email'],
      type: 'email',
      value: this.email,
      required: true,
      maxLength: this.emailMaxLength,
      isInvalid: !!this.emailValidationMessage,
      helperText: this.emailValidationMessage,
      placeholder: trans['email_placeholder'],
      size: 'lg'
    };  
    });
  }

  setButtonConfig() {
    this.signUpConfig = {
      id: 'register-signup-btn',
      label: this.translate.instant('Sign Up'),
      color: "primary", 
      size: "lg",
      block: true,
      disabled: !this.firstname || !this.email,
      ariaLabel: this.translate.instant('Sign Up')
    };
  }
  
  onFirstNameChange(val: string) {
    this.firstname = val;
    this.firstnameInputConfig = {
      ...this.firstnameInputConfig,
      value: val,
      isInvalid: !this.ShowSpecialCharErrorFName,
      helperText: !this.ShowSpecialCharErrorFName ? this.translate.instant('numeric_keys_not_allowed') : '',
    };
    this.setButtonConfig();
  }

  onLastNameChange(val: string) {
    this.lastname = val;
    this.lastnameInputConfig = {
      ...this.lastnameInputConfig,
      value: val,
      isInvalid: !this.ShowSpecialCharErrorLName,
      helperText: !this.ShowSpecialCharErrorLName ? this.translate.instant('numeric_keys_not_allowed') : '',
    };
  }
  
  onEmailChange(val: string) {
    this.email = val;
    this.emailInputConfig = {
      ...this.emailInputConfig,
      value: val,
      isInvalid: !!this.emailValidationMessage,
      helperText: this.emailValidationMessage,
    };
    this.setButtonConfig();
  }

  goToNextStep() {
    this.gotoNextStepEvent.emit(3);
  }

  omitSpecialChar(event: any) {
    if (event.target.id === "first-name-input") {
      if(!this.allowAcuteChar(event)){
      this.firstnameInputConfig = {
        ...this.firstnameInputConfig,
        isInvalid: true,
        helperText: this.translate.instant('numeric_keys_not_allowed'),
      };
    }
    } else {
      if(!this.allowAcuteChar(event)){
      this.lastnameInputConfig = {
        ...this.lastnameInputConfig,
        isInvalid: true,
        helperText: this.translate.instant('numeric_keys_not_allowed'),
      };
     }
    }
    return this.allowAcuteChar(event);
  }

  allowAcuteChar(event: any) {
    let regex = new RegExp("^[a-zA-ZÀ-úp{L} '-]+$");
    let str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (regex.test(str)) 
      return true;
    else return false;
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  onRegistrationSubmit() {
    if (!this.firstname || !this.email) {
      return;
    }
    this.signUpConfig = {
      ...this.signUpConfig,
      disabled: true
    };
    this.ShowSpecialCharErrorFName = true;
    this.ShowSpecialCharErrorLName = true;
    this.claims = new Claims();
    this.submitted = false;
    this.registrationsubmitted = true;

    if (!EMAIL_REGEX.test(this.email)) {
      this.emailValidationMessage = this.translate.instant('label_Emailisnotvalid');
      this.emailInputConfig = {
        ...this.emailInputConfig,
        isInvalid: true,
        helperText: this.emailValidationMessage,
      };
      this.signUpConfig = {
        ...this.signUpConfig,
        disabled: false
      };
      return;
    }
    this.emailValidationMessage = "";
    this.emailInputConfig = {
        ...this.emailInputConfig,
        isInvalid: false,
        helperText: this.emailValidationMessage,
      };
    this.ngxService.start();
    this.IsRegisterCanBeDisabled = true;
    let em = new EmailModel();
    em.to = this.email;
    em.bCC = environment.otpBccEmails;
    em.templateName = "OnboardingOTP";
    em.userId = 0;
    em.subjct = "OTP";
    em.sentTime = 0;
    em.deliveredTime = 0;
    em.status = 1;
    em.emailLogId = this.newGuid();
    var otp = Math.floor(1000 + Math.random() * 9000);
    em.keyValuePairs["OTP"] = otp.toString();

    var domain = this.email;
    this.authenticationService.CheckDomainRegistered(domain).subscribe(
      (domainData: any) => {      
        if (domainData.responseInfo.length == 0 && domainData.statusCode == 0) {
          this.authenticationService
            .checkForUserExistance(this.email)
            .subscribe(
              (userData: any) => {
                // A user who dropped off before organisation setup re-verifies via OTP and resumes onboarding.
                if (userData.responseInfo != null && userData.responseInfo.isOnboardingProcessComplete) {
                  this.toastr.error(this.translate.instant("claimant_exists"), '', {
                    timeOut: 15000
                  });
                  this.signUpConfig = {
                    ...this.signUpConfig,
                    disabled: false
                  };
                  this.IsRegisterCanBeDisabled = false;
                  this.emailAlreadyExists = true;
                } else {
                  this.sendOtpAndContinue(em, otp);
                }
              },
              () => {}
            );
        } else {
          if(domainData.statusCode == 0){
          this.domainName = this.email.split("@").pop() || "";
          if (this.domainModal) {
            this.domainModal.showModal();
            this.signUpConfig = {
              ...this.signUpConfig,
              disabled: false
            };
          }
          return;
          }
          else{
            this.toastr.error(this.translate.instant("claimant_exists"), '', {
              timeOut: 15000
            });
            this.IsRegisterCanBeDisabled = false;
            this.signUpConfig = {
              ...this.signUpConfig,
              disabled: false
            };
            this.emailAlreadyExists = true;

          }
        }
      },
      (error: any) => {}
    );
  }

  sendOtpAndContinue(em: EmailModel, otp: number) {
    const req = new ApiRequest<EmailModel>("", 1, "");
    req.requestInfo = em;
    this.emailService.SendEmail(req).subscribe(() => {
      this.userrequest.RequestInfo = new Userrequestdto();
      this.userrequest.WebApiName = "SoloRegister";
      this.userrequest.WebApiVersion = 1;
      this.userrequest.RequestId = "111";
      this.userrequest.RequestInfo.FirstName =
        this.firstname;
      this.userrequest.RequestInfo.LastName = this.lastname;
      this.userrequest.RequestInfo.LoginId = this.email;
      this.userrequest.RequestInfo.ReferralCode =
        this.referralCode;
      this.userrequest.RequestInfo.OTP = otp;
      localStorage.setItem(
        "registereduser",
        JSON.stringify(this.userrequest.RequestInfo)
      );
      this.ngxService.stop();
      this.gotoNextStepEvent.emit(3);
    });
  }

  newGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  gotoLogin() {
    this.router.navigate(["login"]);
  }

  ngAfterViewInit() {
    const backFromOTP = localStorage.getItem("backFromOTP");
    if (backFromOTP) {
      setTimeout(() => {
        if (this.emailInput) {
        this.emailInput.focus();
        }
      }, 100);
      localStorage.removeItem("backFromOTP");
    }
  }

}
